// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/loading/index.scss
// module id = 104
// module chunks = 0